module.exports = __webpack_public_path__ + "static/fonts/nf.5ada4a12.woff";